import React , {useContext} from "react";
import Aux from "../../../HOC/Aux";
import {RoomContext} from "../../../../Context";
const FavRoom = (props)=>{
    const context = useContext(RoomContext);
    const {deleteRoom, index} =  props;
    const {addToCart} = context;
    const {images, name , price , id} = props.room;
    return(
        <Aux>
                <div className="fav-room-box">
                    <h4 className="fav-room-closing-icon" onClick={()=> deleteRoom("favRooms", id , index )}>&times;</h4>
                    <img className="fav-room-img" src={images[0]} alt={name} />
                    <div className="fav-room-inner">
                        <h5 className="fav-room-name">{name}</h5>
                        <strong className="fav-room-price">${price}</strong><br/>
                        <button className="cart-delete-Btn" style={{fontSize:"15px"}} onClick={()=> addToCart("cartRooms",id)}>Add / remove from reservation box</button>
                    </div>
                </div>
        </Aux>
    )
}
export default FavRoom;